module.exports = __webpack_public_path__ + "img/MT.1122ea84.png";